import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export async function postForm(path, payload) {
  if (!BASE) throw new Error("The form service is not configured.");
  const { data } = await axios.post(`${BASE}/api${path}`, payload, { timeout: 20000 });
  return data;
}
